import type { Heading } from '@ps/web-martech-cms-types';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { HTMLAttributes } from 'react';
import React from 'react';

import { CMSLink } from '@swf/cms';

import useAuthenticatedContent from '../../hooks/useAuthenticatedContent';

import styles from './CMSHeading.scss';

const CMSHeading: React.FC<Heading & Partial<ClassNameProp>> = ({
  level = 'h1',
  title,
  text_color: textColor,
  url,
  target,
  rel,
  alignment,
  anchor,
  className,
  size,
  hero,
  logged_in_title: loggedInTitle
}) => {
  const headingTitle = useAuthenticatedContent(title, loggedInTitle);

  if (!headingTitle) {
    return null;
  }

  const getSize = (element: string) => {
    switch (element) {
      case 'h1':
        return 'l';
      case 'h2':
        return 'm';
      case 'h3':
        return 's';
      default:
        return 'xs';
    }
  };
  const El = level || 'h1';
  const headingClassName = `${size || getSize(level as string)}${
    hero ? 'Hero' : ''
  }` as keyof typeof styles;
  const elementProps: HTMLAttributes<HTMLHeadingElement> = {
    className: classNames(styles[headingClassName], className, alignment && styles[alignment])
  };
  if (anchor) elementProps.id = anchor;
  if (textColor) elementProps.style = { color: textColor };

  return (
    <El {...elementProps}>
      {url ? (
        <CMSLink
          url={url}
          className={styles.link}
          title={headingTitle}
          target={target ?? '_self'}
          rel={rel}
        />
      ) : (
        headingTitle
      )}
    </El>
  );
};

export default CMSHeading;
